import { AVAILABILITY_MODE } from '../constants/availabilityModes'
import { TIMEZONE_MODE } from '../constants/timezone'

export const createEmptyAvailability = (overrides = {}) => ({
  mode: AVAILABILITY_MODE.fixedDuration,
  openFor: { value: 2, unit: 'hours' },
  dailyWindow: {
    enabled: false,
    from: '08:00',
    until: '14:00',
    timezone: TIMEZONE_MODE.participantLocal,
  },
  ...overrides,
})
